import { KebabMenu, ListItemText, MenuItem, MenuItemProps } from '@cmg/design-system';

export type ContextMenuActionsProps = Readonly<Pick<MenuItemProps, 'key' | 'onClick'>> & {
  readonly label: string;
};

type ContextMenuActionsComponentProps = Readonly<{
  contextMenuActions: readonly ContextMenuActionsProps[];
}>;

export function ContextMenuActions({ contextMenuActions }: ContextMenuActionsComponentProps) {
  return (
    <KebabMenu>
      {contextMenuActions.map(action => {
        return (
          <MenuItem key={action.key} onClick={action.onClick}>
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        );
      })}
    </KebabMenu>
  );
}
